import { Editor } from "../../../../features/Editor";
import { EditorPage } from "../../../../pages/EditorPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const applicationsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.ai_agents_spa.root,
  element: <EditorPage />,
  name: "Редактор",
  children: appRouterPaths.ai_agents_spa.item
    ? [
        {
          path: appRouterPaths.ai_agents_spa.item,
          element: <Editor />,
          name: "Объект редактора",
        },
      ]
    : undefined,
};
